var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"line"},[(!!_vm.icon)?_c('idf-icon',{attrs:{"kind":_vm.icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))]),_vm._v(" : "),_c('span',{staticClass:"line__data"},[_vm._v(_vm._s(_vm.data || '-'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }